module.exports = __webpack_public_path__ + "static/media/protection.9452ebf0.svg";